module.exports = __webpack_public_path__ + "static/media/graylinxlogo6.f6c9beeb.png";